import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService} from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    // store the URL so we can redirect after logging in
    redirectUrl: string;

    constructor(private authService: AuthService, private router: Router) {}

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //     // if (this.oauthService.hasValidIdToken()) {
    //     //     return true;
    //     // }
    //
    //     if (this.authService.isAuthenticated()) {
    //         console.log('Logged in already!');
    //         return true;
    //     }
    //
    //     // this.router.navigate(['/home']); -- original
    //     // this.router.navigate(['/auth/login']);
    //     console.log('Not logged in yet!');
    //     this.authService.login();
    //     // this.router.navigate(['/home']);
    //     // this.router.navigate( this.redirectUrl ? [this.redirectUrl] : ['/home']);
    //     return false;
    // }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;

        return this.checkLogin(url);
    }

    checkLogin(url: string): boolean {

        if(this.authService.isAuthenticated()) {return true;}

        // Store the attempted URL for redirecting
        this.authService.redirectUrl = url;

        // Navigate to the login page with extras
        // this.authService.login();
        this.router.navigate(['auth/login']);
        return false;
    }

}


// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/+auth/auth-guard.service.ts